import { useState } from "react";
import { AlertTriangle, Circle, CircleCheck, Lock } from "lucide-react";
import { toast } from "@/lib/toast";
import api from "@/lib/api";
import { useCrmAdmin } from "@/components/crm/crmShared";
import { FORMULE_META, FormuleIcon } from "@/components/crm/FormuleIcon";

/** iter361 pt.3 (modèle F1) — onglet « Formule de l'acte » du projet : 2 grandes cartes + ligne de rappels. */
export default function ProjectFormuleTab({ project, onSaved }) {
  const isAdmin = useCrmAdmin();
  const [busy, setBusy] = useState(false);
  const choose = async (v) => {
    if (!isAdmin || busy || v === project.formule) return;
    setBusy(true);
    try { await api.patch(`/crm/projects/${project.id}`, { formule: v }); toast.success("Formule enregistrée"); onSaved?.(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Enregistrement impossible"); } finally { setBusy(false); }
  };
  return (
    <section data-testid="crm-project-formule-tab" style={{ maxWidth: 760 }}>
      <div className="flex items-center" style={{ gap: 8, marginBottom: 12 }}>
        <span style={{ fontSize: 13, fontWeight: 700, color: "#e8e6df" }}>Formule de l'acte</span><span style={{ color: "#E0A42E" }}>*</span>
        {!isAdmin && <span className="inline-flex items-center" style={{ gap: 4, fontSize: 10, color: "#8b8b93", border: "0.5px solid #2a2a30", borderRadius: 20, padding: "2px 8px" }}><Lock size={10} /> Admins</span>}
      </div>
      {!project.formule && <div className="flex items-center" style={{ gap: 8, padding: "8px 12px", borderRadius: 8, border: "1px dashed #6a5226", color: "#E0A42E", fontSize: 11.5, marginBottom: 12 }} data-testid="crm-project-formule-missing"><AlertTriangle size={14} /> Formule à définir — aucune vente ne peut être confirmée sans formule.</div>}
      <div className="grid" style={{ gridTemplateColumns: "1fr 1fr", gap: 14 }} data-testid="crm-project-formule">
        {Object.entries(FORMULE_META).map(([v, m]) => {
          const on = project.formule === v;
          return (
            <button key={v} type="button" disabled={!isAdmin || busy} onClick={() => choose(v)} className="flex flex-col items-start text-left"
              style={{ gap: 10, padding: "20px 22px", minHeight: 150, borderRadius: 12, border: on ? "1px solid #E0A42E" : "0.5px solid #2a2a30", background: on ? "#1a160e" : "#18181d", cursor: isAdmin ? "pointer" : "not-allowed", transition: "border-color .15s, background-color .15s" }}
              data-testid={`crm-project-formule-${v}`} aria-pressed={on}>
              <span className="flex items-center" style={{ gap: 10, width: "100%" }}>
                <FormuleIcon value={v} active={on} size={26} />
                <span style={{ flex: 1 }} />
                {on ? <CircleCheck size={20} style={{ color: "#E0A42E" }} /> : <Circle size={20} style={{ color: "#4a4a55" }} />}
              </span>
              <span style={{ fontSize: 17, fontWeight: 700, color: on ? "#E0A42E" : "#e8e6df" }}>{m.label}</span>
              <span style={{ fontSize: 11.5, color: "#8a8a93" }}>{m.sub}</span>
            </button>
          );
        })}
      </div>
      <div style={{ fontSize: 11, color: "#9a9aa3", marginTop: 14, lineHeight: 1.6 }} data-testid="crm-project-formule-reminders">
        Verrouillée sur la vente · Obligatoire avant toute vente · TVA : taux propre à chaque lot · <span style={{ whiteSpace: "nowrap" }}>Livraison prévue = dernière étape dans « Avancement des travaux »</span>
      </div>
    </section>
  );
}
